
import { computed, defineComponent, ref, toRefs } from "vue";
import unitPresets from "@/assets/data/unit-presets.json";
import SelectInput from "./SelectInput.vue";
import useToolbar from "@/composables/useToolbar";

export default defineComponent({
  name: "NumberInput",
  components: { SelectInput },
  props: {
    label: String,
    modelValue: {
      type: Number,
      default: NaN
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: Infinity
    },
    step: {
      type: Number,
      default: 1
    },
    placeholder: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    freeze: {
      type: String
    },
    optional: { type: Boolean }
  },
  setup(props, { emit }) {
    const { global } = useToolbar();
    const { unit } = toRefs(global);
    const inputRef = (ref(null) as unknown) as { value: HTMLInputElement };

    const name = computed(() => props.modelValue.toString().toLowerCase());
    const active = ref(false);

    const canIncrease = computed(() => props.modelValue < props.max);
    const canDecrease = computed(() => props.modelValue > props.min);

    const decrease = (event: KeyboardEvent) => {
      if (!canDecrease.value) return;
      const stepFactor = event.shiftKey ? 10 : 1;

      const newValue: number =
        Math.round(
          (+inputRef.value.value - props.step * stepFactor + Number.EPSILON) *
            10000
        ) / 10000;

      emit("update:modelValue", newValue);
    };

    const increase = (event: KeyboardEvent) => {
      if (!canIncrease.value) return;
      const stepFactor = event.shiftKey ? 10 : 1;
      const newValue: number =
        Math.round(
          (+inputRef.value.value + props.step * stepFactor + Number.EPSILON) *
            10000
        ) / 10000;

      emit("update:modelValue", newValue);
    };

    // TODO:
    // if input:invalid deal with red styles
    // call function on input @invalid event

    return {
      inputRef,
      canIncrease,
      canDecrease,
      increase,
      decrease,
      unit,
      unitPresets,
      name,
      active
    };
  }
});
